import { IAutoStakeResponse } from "../../utils/types";
import { Link } from "react-router-dom";

const AutoStakeListTable = ({
    autoStakes,
    stopAutoStake
}: {
    autoStakes: IAutoStakeResponse[];
    stopAutoStake: (stakeId: number) => Promise<void>;
}) => {

    return (
        <div className="mt-8">
        <h2 className="text-lg font-semibold text-black dark:text-white mb-4">Running Auto Stakes</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white dark:bg-black/20 rounded-lg shadow">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Subnet</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Stake Amount</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Stake Price</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Unstake Price</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Repeat</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Staked</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-white">Action</th>
              </tr>
            </thead>
            <tbody>
              {autoStakes.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-4 py-4 text-center text-gray-500 dark:text-gray-300">
                    No running auto stakes found.
                  </td>
                </tr>
              ) : (
                autoStakes.map((stake) => (
                  <tr key={stake.id} className="border-b border-gray-200 dark:border-gray-700 text-black dark:text-white">
                    <td className="px-4 py-2">
                      <Link to={`/subnet/${stake.subnet_id}`} className="text-blue-500 underline hover:text-blue-700">
                        {stake.subnet_id}
                      </Link>
                    </td>
                    <td className="px-4 py-2">{stake.stake_amount}</td>
                    <td className="px-4 py-2">{stake.stake_price}</td>
                    <td className="px-4 py-2">{stake.unstake_price}</td>
                    <td className="px-4 py-2">
                      {stake.repeat_cnt === -1 ? "Until stopped" : stake.repeat_cnt}
                    </td>
                    <td className="px-4 py-2">{stake.staked ? "Yes" : "No"}</td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() => stopAutoStake(stake.id)}
                        className="text-red-500 hover:text-red-700"
                      >
                        Stop
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
}

export default AutoStakeListTable;